<ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup">
        <div formArrayName="customers">
            <mat-accordion multi="true" class="bg-white">
                <mat-expansion-panel
                    *ngFor="let customer of customers.controls; let i = index"
                    [formGroupName]="i"
                    [expanded]="true"
                    class="bg-white"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mt-4 mb-4">
                            Customer<ng-container *ngIf="customers.length > 1">
                            {{i + 1}}</ng-container>
                            : {{customer.controls.firstName.value}} {{ customer.controls.lastName.value }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <app-forms-customer [formGroup]="customer"></app-forms-customer>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </form>
</ng-container>
